<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title" id="part01"><a id="page_17"><span class="small">DEVELOPING, CHANGING</span></a><a id="page_18"></a></p><a id="page_18">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?67f299e9